import { IconProps } from './types';

export const UserIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26.692 26.692'>
    <path
      // eslint-disable-next-line max-len
      d='M18.346,18.346a6.173,6.173,0,1,0-6.173-6.173A6.171,6.171,0,0,0,18.346,18.346Zm0,3.087C14.226,21.433,6,23.5,6,27.606v3.087H30.692V27.606C30.692,23.5,22.467,21.433,18.346,21.433Z'
      transform='translate(-5 -5)'
      fill='none'
      stroke='#fff'
      strokeWidth='2'
      {...props}
    />
  </svg>
);

export const UsersIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14.921 9.786'>
    <path
      // eslint-disable-next-line max-len
      d='M11.128,11.351A1.926,1.926,0,1,0,9.2,9.426,1.918,1.918,0,0,0,11.128,11.351Zm-5.135,0A1.926,1.926,0,1,0,4.067,9.426,1.918,1.918,0,0,0,5.993,11.351Zm0,1.284c-1.5,0-4.493.751-4.493,2.246v1.6h8.986v-1.6C10.486,13.386,7.489,12.635,5.993,12.635Zm5.135,0c-.186,0-.4.013-.623.032a2.709,2.709,0,0,1,1.264,2.214v1.6h3.851v-1.6C15.621,13.386,12.623,12.635,11.128,12.635Z'
      transform='translate(-1.1 -7.1)'
      fill='none'
      stroke='#fff'
      strokeWidth='0.8'
      {...props}
    />
  </svg>
);
